import api from '@/api'

export default {
  // 购买教练并生成订单
  orderAdd (data) {
    return api({
      url: '/pay/orderAdd',
      method: 'POST',
      data
    })
  },
  // 续费教练并生成订单
  renewAdd (data) {
    return api({
      url: '/pay/renewAdd',
      method: 'POST',
      data
    })
  },
  // 获取订单列表-系统管理员
  getOrderSystemPage (params) {
    return api({
      url: '/pay/orderListSystem',
      method: 'GET',
      params
    })
  },
  // 获取订单列表-机构/俱乐部
  getOrderYouthPage (params) {
    return api({
      url: '/pay/orderListYouth',
      method: 'GET',
      params
    })
  },
  // 获取续费订单列表-系统管理员
  getRenewSystemPage (params) {
    return api({
      url: '/pay/renewListSystem',
      method: 'GET',
      params
    })
  },
  // 获取续费订单列表-机构/俱乐部
  getRenewYouthPage (params) {
    return api({
      url: '/pay/renewListYouth',
      method: 'GET',
      params
    })
  },
  // 根据教练订单uuid获取订单详情
  getOrderDetail (orderUuid) {
    return api({
      url: `/pay/orderInfo/${orderUuid}`,
      method: 'get',
    })
  },

  // 对订单进行支付  （支付宝 alipay-pcweb, 微信 wechat-pcweb , 银行 transfer） returnUrl 支付宝支付完成后跳转的链接
  payOrder (orderUuid,payType,returnUrl) {
    return api({
      url: `/pay/pay/${orderUuid}`,
      method: 'get',
      params:{
        payType,
        returnUrl
      }
    })
  },
  // 获取订单状态
  getOrderStatus (orderUuid) {
    return api({
      url: `/pay/orderStatus/${orderUuid}`,
      method: 'get'
    })
  },
  // 获取订单数量
  getRenewYouthNum (params) {
    return api({
      url: `/pay/renewYouthNum`,
      method: 'get',
      params,
    })
  },

}
